import React from 'react';
import { X, Crown, Gamepad2, Save, Zap, Star, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import './UpgradeModal.css';

function UpgradeModal({ 
  isOpen, 
  onClose, 
  limitType = 'play', // 'play' or 'save'
  currentCount = 0,
  maxCount = 3
}) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleUpgrade = () => {
    navigate('/profile');
    onClose();
  };

  const isPlayLimit = limitType === 'play';
  const Icon = isPlayLimit ? Gamepad2 : Save;
  const title = isPlayLimit 
    ? 'Play Limit Reached!' 
    : 'Save Limit Reached!';
  const description = isPlayLimit
    ? `You've played ${currentCount} out of ${maxCount} free games.`
    : `You've saved ${currentCount} out of ${maxCount} free games.`;

  return (
    <div className="upgrade-modal-overlay" onClick={onClose}>
      <div className="upgrade-modal" onClick={e => e.stopPropagation()}>
        <button className="upgrade-modal-close" onClick={onClose}>
          <X size={20} />
        </button>

        <div className="upgrade-modal-header">
          <div className="limit-icon-wrapper">
            <Icon size={32} className="limit-icon" />
          </div>
          <h2>{title}</h2>
          <p className="limit-description">{description}</p>
        </div>

        <div className="upgrade-modal-content">
          <div className="upgrade-prompt">
            <Crown className="crown-icon" size={48} />
            <h3>Upgrade to Premium</h3>
            <p>Unlock unlimited access to all features!</p>
          </div>

          <div className="premium-features">
            <h4>Premium Benefits:</h4>
            <ul>
              <li>
                <CheckCircle size={16} className="check-icon" />
                <span><strong>Unlimited</strong> game saves</span>
              </li>
              <li>
                <CheckCircle size={16} className="check-icon" />
                <span><strong>Unlimited</strong> game plays</span>
              </li>
              <li>
                <CheckCircle size={16} className="check-icon" />
                <span>Priority support</span>
              </li>
              <li>
                <CheckCircle size={16} className="check-icon" />
                <span>Early access to new games</span>
              </li>
            </ul>
          </div>

          <div className="upgrade-actions">
            <Button 
              className="upgrade-btn"
              onClick={handleUpgrade}
            >
              <Zap size={18} />
              Upgrade Now
            </Button>
            <Button 
              variant="outline" 
              onClick={onClose}
              className="cancel-btn"
            >
              Maybe Later
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpgradeModal;
